import store from '@/store';

function restoreUserSession(from, to, next) {
  store.dispatch('restoreUserSessionFromToken', store.state.localToken)
    .then(() => {
      next();
    });
};

export default (from, to, next) => {
  if (store.getters.hasSavedSession) {
    return restoreUserSession(from, to, next);
  }

  if (!store.getters.loggedIn) {
    return next('/auth/login');
  }

  return next();
};
